import { render } from "./AppVolleyball.vue?vue&type=template&id=71105aa8&ts=true"
import script from "./AppVolleyball.vue?vue&type=script&lang=ts"
export * from "./AppVolleyball.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__